export const AssetInfo = {
  note:
    'Assets are used by your employees to perform tasks. ' +
    'The system allows for assets to be grouped by category and for you to create your own asset types. ' +
    'Asset types allow you to specify if the assets of that type require qualifications or for a handover process to be performed. ' +
    'Phones are used to manage SRM-Sentry and link the system to your company (This is what allows guards to login with their Employee ID). ' +
    'Phones need to be registered using an OTP and Vehicles must have a registration as their asset id.',
  assetId: 'An id used to uniquely identify your assets.',

  typeId: 'An id used to uniquely identify your assets types.',
  category:
    'Categories help organise the assets. In particular Phones are required by the system to register SRM-Sentry.',
  types:
    'Asset types are created to group assets. In particular it is used to identify assets that need qualifications or handover processes.',
  newType: 'Create a new asset type to assign to the asset.',
  handOver:
    'Identifies that a handover must be performed for the assets. Each party involved in the handover will confirm they have performed the appropriate process.',
  qualifications: 'Used to determine if a user can use an asset of this type.',
};
export const CustomerInfo = {
  note:
    'A customer is added so that they can request services and monitor events and incidents in SRM-Customer. ' +
    'They will be emailed log in details and asked to set up their password. ' +
    'Only add a customer if you want them to request services and access published events.',
  customerId: 'An id you use to uniquely identify your customers.',
  email:
    'A unique email address used to send account information and reset passwords.',
  businessClient:
    'All customers belong to a business client you have entered into the system',
  languages: 'Select the languages this customer prefers to interact in.',
};
export const EmployeeInfo = {
  managerSupervisorNote:
    'Managers and Supervisors are personnel that use SRM-Portal. A Manager can access the Managerial and Reporting views. ' +
    'This allows them to manage company data and generate reports for clients. ' +
    'Both Supervisors and Managers can access the Operational and Emergency Response Views allowing them to monitor and manage day-to-day incidents and patrols. ' +
    'Creating an account will send them an email to set their password and count towards your account plan. ' +
    'Both can act as Responders allowing them to use SRM-Responder to perform operational tasks .' +
    'A person who is both a Manager/Supervisor and a Responder will count towards both your Manager/Supervisor limit and Responder limit.',
  supervisorResponderGuardNote:
    'Supervisors are personnel that can use SRM-Portal to access Operational and Emergency Response Views allowing them to monitor and manage day-to-day incidents and patrols.' +
    'Supervisor can act as as Responders allowing them to use SRM-Responder to perform operational tasks. ' +
    'A person who is both a Supervisor and a Responder will count towards both your Manager/Supervisor subscription limit and Responder limit. ' +
    'Responders are mobile users who are independent of your sites. They can use SRM-Responder to perform operational tasks. ' +
    'Creating a Supervisor or Responder account will send them an email to set their password and count towards your account plan. ' +
    'Guards are users that can use SRM-Sentry to perform operational tasks. ' +
    'Typically they are assigned to a site where they will perform patrols and notify Supervisors of incidents. ' +
    'Guards do not count towards your subscription limit but can only log into registered versions of SRM-Sentry.',
  employeeId: 'An id used to uniquely identify your personnel.',
  guardId: 'An id used to allow guards to log in to SRM-Sentry.',
  isResponder: 'Allows the user to perform tasks using SRM-Responder.',
  isTeamLead:
    'Allows the user to perform additional tasks using their mobile app.',
  email:
    'A unique email address used to send account information and reset passwords.',
  responderServices:
    'Selecting services here will allow the person to perform those tasks in SRM-Responder.',
  guardServices:
    'Selecting services here will allow the person to perform those tasks in SRM-Sentry.',
  qualifications:
    'Used to determine if a user can use an asset or access a site.',
  languages:
    'Used for information purposes to assist in selecting users to perform a task.',
  passCode: 'Used by Guards to log in to SRM-Sentry with their Employee id.',
};

export const BusinessClientInfo = {
  id: 'An id used to uniquely identify your business client.',
  note:
    "Business Client's are your customers. " +
    'Creating them allows you to add sites and site patrols. ' +
    "If you wish to have your client's representative notified in realtime of events then add them as a contact and get them to install SRM-Customer.",
  address:
    'The address is used to notify users of where the Business Client is located.',
  contact:
    ' A contact is added to inform the user of events and incidents on their site in SRM-Customer. ' +
    'Only add a contact if you want them to request services and access published events.',
  newContact:
    ' Create a new contact. A contact is added to inform the user of events and incidents on their site in SRM-Customer. ' +
    'Only add a contact if you want them to request services and access published events.',
};
export const PatrolDefInfo = {
  note:
    'Patrols are tasks performed by Guards and Responders to ensure things are in order at a location. ' +
    'They can be mobile or site specific. ' +
    'Patrols can be scheduled to ensure they are performed, or assigned to a logged in user during operations.' +
    'Patrols checkpoints wil generate QR codes that can be printed out and placed at the selected location for users to scan.',
  mobile:
    'A mobile patrol can only be performed by persons with the Mobile Patrol service using SRM-Responder or SRM-Sentry.',
  site:
    'The site where the patrol will occur. Links the patrol for reporting to your Business Clients.',
  siteSurfaceImages:
    'Draw patrols on a site image instead of the geographical map. Selecting an image will prevent you from choosing mobile patrol.',
  newSite: 'Create a new site to link to your Business Clients.',
  everyDay: 'The patrols should be run every day of the week.',
  returnToStart:
    'First checkpoint should be scanned again after completing the patrol',
  virtualPatrol:
    'Virtual patrols can be performed without attending the physical locations. No proximity incident reports will be generated for virtual patrols',
  allDay: 'The patrols should be run all day from midnight to midnight.',
  start:
    'Select the time the patrol should start. Limited to 5 minutes increments.',
  end:
    'Select the time the patrol should finish. Limited to 5 minutes increments.',
  interval:
    'The patrols should be scheduled from the start time of that day with the selected interval.',
  duration: 'How long each patrol should take in minutes.',
  schedule:
    'The schedule will be sent out based on the days of the week, hours to be performed and interval. ' +
    'If a schedule is missed a Missed Patrol Event is created.',
  checkpoints:
    'Select where the patrol will be performed. ' +
    'Create waypoints then select them again to make them a checkpoint. ' +
    'Each checkpoint will create a QR code that can be printed and placed at the location.',
};

export const SiteInfo = {
  note:
    'A site is a location that the company is contracted to work at. ' +
    'It allows for the creation of Site Patrols and for guards to be assigned.' +
    'Assigned guards can use SRM-Sentry to perform site patrols.',
  siteId: 'An id you use to uniquely identify the site.',
  businessClient:
    'The company that owns the site and needs to be informed when things occur on the site.',
  contact: BusinessClientInfo.contact,
  visitor: 'Select if you wish to report visitors to the site in SRM-Sentry.',
  pass:
    'Require visitors to wear a visible pass while on site. A site can allow only specific passes or any SRM pass created by your company.',
  photo:
    'Require a photograph of the visitor. You can set this to not allowed to prevent your guards from photographing.',
  photoId:
    "Require a photograph of the visitor's . You can set this to not allowed to prevent your guards from photographing.",
  address: 'The address is used to assist users in locating the site.',
};
export const ZoneInfo = {
  note:
    'A zone highlights an area of significance to the users. ' +
    'It provides them with information so that they can take adequate precautions when entering the zone.',
  name: 'A name used to identify the zone.',
  hazard: 'What is causing the risk level in the zone.',
  consequence: 'The impact to a person entering the zone.',
  likelihood:
    'The chance of the hazard causing an impact to a person in the zone.',
  riskLevel: 'The calculated risk in the zone.',
  recommendation: 'What should the person do in relation to this zone.',
};

export const TimeInfo = {
  timezone:
    'Select the standard timezone (without Daylight savings). The system will automatically convert schedules and reports for Daylight savings.',
};

export const EventInfo = {
  note:
    'Event reports provide valuable information to the users in the region. ' +
    'You can choose to share reports by publishing them and setting the distribution.' +
    'Events can be accessed in SRM-Portal, SRM-Responder and SRM-Customer.',
  title:
    'Helps users to quickly understand what the report is about. Think of this like a news headline.',
  category:
    'Event categories provide an easy way to sort information. News is shown in a different colour to incidents.',
  types:
    'Types are specific types for each category and allow users to understand the nature of the event.',
  start:
    'Identifies when the event started. Used in conjunction with the finish time to specify the status of the event.',
  end:
    'Identifies when the event finished. Used in conjunction with the start time to specify the status of the event.',
  reporters: 'The people who provided the information.',
  websites: 'The websites that provided the information.',
  reliability:
    'How credible do you believe the source, that is providing the information, is.',
  company: 'The name of the company that provided the information.',
  assets:
    'Any assets that your company manages that were involved in the event.',
  locations:
    'Add any locations that were involved with the event. You can add a single point, many points, or select an area.',
  public:
    'Required summary that is shown to everyone and will be available to the public if the event is published and distributed to the public.',
  client:
    'Description that is shown to your companies personnel and will be available to your client if the event is published and distributed to your business client or the public.',
  internal:
    'Description that is shown to your companies personnel unless the event is only distributed to management.',
  involvedPeople:
    'A person involved with the event. This could be a witness, perpetrator, etc.',
  involvement: 'How was the person involved?',
  involvedCompanies:
    'The company involved. Add your business client here if you want them to see this report in the SRM-Customer app.',
  recommendations:
    'Provide any number of recommended actions for different audiences.',
  media:
    'Upload images and audio related to the incident. The first image will be the thumbnail view for the event.',
  when: 'Optional description to describe when the incident happened.',
  where: 'Optional description to describe where the incident happened.',
  why: 'Optional description to describe why the incident happened.',
  what: 'Optional description to describe what happened.',
  how: 'Optional description to describe how the incident happened.',
  who: 'Optional description to describe who was involved in the incident.',
};

export const TaskInfo = {
  everyDay: 'The task should be run every day of the week.',
  allDay: 'The tasks should be run all day from midnight to midnight.',
  start: 'Select the time the task should start.',
  end: 'Select the time the task should finish.',
  site:
    'The site where the task will occur. Links the task for reporting to your Business Clients.',
  duration: 'How long the task is expected to take in minutes.',
  interval: 'Repeat the task at intervals during the day.',
  siteSurfaceImages:
    'Draw patrols on a site image instead of the geographical map. Selecting an image will prevent you from choosing mobile patrol.',
  reorder:
    'Select sequential order to get your personnel to perform their tasks in a specific order. Drag and drop subtasks to change the subtask sequence',
  dailyInterval: 'Repeat the task at intervals during the day',
  endTimeOnly:
    'If the finish time is earlier than the Start time it will be assumed to finish on the next day.',
  rescheduleWeekends:
    'If the schedule falls on a weekend this will allow it to be rescheduled to a weekday.',
  rescheduleInvalidDates:
    'If the chosen date does not exist for the current month this will allow it to be rescheduled.',
  days: 'Select each day you wish to schedule your task.',
};

export const MessageInfo = {
  note: 'Send a message to a personnel.',
};
export const DepartmentInfo = {
  note:
    'Account Holders can create new Departments to manage the allocation of responsibilities and access to resources.',
};
